import img1 from "../batens_verden/images/1.webp";
import img2 from "../batens_verden/images/2.webp";
import img3 from "../batens_verden/images/3.webp";

import cormate from "../batens_verden/images/cormate.gif";
import orsta from "../batens_verden/images/orsta.webp";
import orsta2 from "../batens_verden/images/orsta2.webp";
import orsta3 from "../batens_verden/images/orsta3.webp";
import boatboot from "../batens_verden/images/boatboot.webp";

import viknes from "../batens_verden/images/viknes.webp";
import skilso from "../batens_verden/images/skilso.webp";
import langsjo from "../batens_verden/images/langsjo.webp";
import seadoo from "../batens_verden/images/seadoo.webp";
import seadoo2 from "../batens_verden/images/seadoo2.webp";
import seadoo3 from "../batens_verden/images/seadoo3.webp";
import nordkapp from "../batens_verden/images/nordkapp.webp";
import nordkapp2 from "../batens_verden/images/nordkapp2.webp";
import nordkapp3 from "../batens_verden/images/nordkapp3.webp";
import gjensidige from "../batens_verden/images/gjensidige.webp";
import greatwhite from "../batens_verden/images/greatwhite.webp";
import greatwhite2 from "../batens_verden/images/greatwhite2.webp";
import hcc from "../batens_verden/images/hcc.webp";
import kystverket from "../batens_verden/images/kystverket.webp";

import lasa from "../batens_verden/images/lasa.webp";
import leks from "../batens_verden/images/leks.webp";
import gigant from "../batens_verden/images/gigant.webp";
import simrad from "../batens_verden/images/simrad.webp";
import nordic from "../batens_verden/images/nordic.webp";
import coastkey1 from "../batens_verden/images/coastkey1.gif";
import coastkey2 from "../batens_verden/images/coastkey2.gif";
import norsk from "../batens_verden/images/norsk.webp";
import norsk2 from "../batens_verden/images/norsk2.webp";

import sandoy from "../batens_verden/images/sandoy.webp";
import seatek from "../batens_verden/images/seatek.webp";
import seatek2 from "../batens_verden/images/seatek2.webp";
import seatek3 from "../batens_verden/images/seatek3.webp";
import seatek4 from "../batens_verden/images/seatek4.webp";
import seakeeper from "../batens_verden/images/seakeeper.webp";

import sjofart from "../batens_verden/images/sjofart.webp";
import stromso from "../batens_verden/images/stromso.webp";
import sunstream from "../batens_verden/images/sunstream.webp";
import oslo from "../batens_verden/images/oslo.webp";

import kellox from "../batens_verden/images/kellox.webp";
import kellox2 from "../batens_verden/images/kellox2.webp";

import pioner from "../batens_verden/images/pioner.webp";
import pioner2 from "../batens_verden/images/pioner2.webp";

import terhi from "../batens_verden/images/terhi.webp";
import micore from "../batens_verden/images/micore.webp";


/*--real*--*/
import sunstream2 from "../batens_verden/images/sunstream2.webp";
import skippern from "../batens_verden/images/skippern.webp";
import skippern2 from "../batens_verden/images/skippern2.webp";

import toxiclean from "../batens_verden/images/toxiclean.webp";
import busterBoats from "../batens_verden/images/busterBoats.webp";
import yamarinCross from "../batens_verden/images/yamarinCross.webp";
import yamarinBoats from "../batens_verden/images/yamarinBoats.webp";
import akeryachts from "../batens_verden/images/akeryachts.webp";

import pioner3 from "../batens_verden/images/pioner3.webp";

import mercury from "../batens_verden/images/mercury.webp";

import eksempel from "../batens_verden/images/eksempel.webp";


let orstaStyle = {
	bg: "#015581",
	logoBg: "#ffde59",
	logoColor: "black",
}

let utstillereFake = [
	{
		wideImage: img3,
		description: "Oppdag nye Honda BF350 - V8-eren du har ventet på",
		firm: "Kellox",
		l: "https://kellox.no/pahengsmotor/honda-marine/honda-marine-bf-350-v8/"
	},
	{
		wideImage: viknes,
		description: "Se full walkthrough av nye Viknes 10 – og opplev den på Sjøen for Alle",
		firm: "Viknes",
		l: "",
	},
	{
		wideImage: skilso,
		description: "Opplev Skilsø sine familiebåter- vi viser Skilsø 35 og 39",
		firm: "Skilsø",
		l: "",
	},
	{
		wideImage: langsjo,
		description: "Nå kommer Snipan af Musö til Norge og Sjøen for Alle",
		firm: "Långsjö Båtbyggeri",
		l: "",
	},
	{
		wideImage: seadoo,
		description: "Her er Sea-Doo-vannscooterserien for 2025",
		firm: "SeaDoo",
		l: "",
	},
	{
		wideImage: seadoo2,
		description: "Oppdag nye muligheter med Sea‑Doo FishPro, vannscooteren designet for fiske",
		firm: "SeaDoo",
		l: "",
	},
	{
		wideImage: seadoo3,
		description: "Vannscooter til sommeren? Sea-Doo viser årets vannscootere",
		firm: "SeaDoo",
		l: "",
	},
	{
		wideImage: nordkapp,
		description: "Opplev mulighetene med Nordkapp Avant",
		firm: "Nordkapp Boats",
		l: "",
	},
	{
		wideImage: nordkapp2,
		description: "Utforsk den uslåelige Nordkapp Airborne 8",
		firm: "Nordkapp Boats",
		l: "",
	},
	{
		wideImage: nordkapp3,
		description: "En detaljert gjennomgang av nyheten Nordkapp Coupe 780",
		firm: "Nordkapp Boats",
		l: "",
	},
	{
		wideImage: gjensidige,
		description: "Trygghet på sjøen – treff Gjensidige på Sjøen for Alle",
		firm: "Gjensidige",
		l: "",
	},
	{
		wideImage: greatwhite,
		description: "GreatWhite har din neste gummibåt eller RIB",
		firm: "Greatwhite of Sweden",
		l: "",
	},
	{
		wideImage: greatwhite2,
		description: "Se HIDEA utenbordsmotorer på Sjøen for Alle – fra 2,5 – 60 hk.!",
		firm: "Greatwhite of Sweden",
		l: "",
	},
	{
		wideImage: hcc,
		description: "Se hva som kommer på Sjøen for Alle – seiler på luftsystem!",
		firm: "HCC Bådeværft",
		l: "",
	},
	{
		wideImage: kystverket,
		description: "42 omkom i norske havner – her er enkle grep som kan redde liv",
		firm: "Kystverket",
		l: "",
	},
	{
		wideImage: lasa,
		description: "Snakk med oss om Volvo Penta på Sjøen for Alle",
		firm: "La-Sa Båt og Motor",
		l: "",
	},
	{
		wideImage: leks,
		description: "Opplev spenning og frihet på vannet med Sea-Doo!",
		firm: "LEKS Motor",
		l: "",
	},
	{
		wideImage: gigant,
		description: "En ny serie hydrauliske slipphengere – møt oss på messa",
		firm: "Gigant Marine",
		l: "",
	},
	{
		wideImage: simrad,
		description: "Snakk navigasjon med oss på Sjøen for Alle",
		firm: "Simrad",
		l: "",
	},
	{
		wideImage: norsk,
		description: "Snakk med oss om båtførerprøven og D5L",
		firm: "Norsk Maritimt Kurssenter",
		l: "",
	},
	{
		wideImage: norsk2,
		description: "Vær med i trekningen av D5L og Båtførerkurs på Sjøen for Alle!",
		firm: "Norsk Maritimt Kurssenter",
		l: "",
	},
	{
		wideImage: seatek,
		description: "Denne gyrostabilisatoren reduserer opptil 95 % av båtens slingring",
		firm: "Sea-Tek",
		l: "",
	},
	{
		wideImage: seatek2,
		description: "Få en demo. Bli forbløffet! Prøv Seakeeper gyrostabilisator på Sjøen for Alle!",
		firm: "Sea-Tek",
		l: "",
	},
	{
		wideImage: seatek3,
		description: "Stabilisator for båter ned til 23 fot. Oppdag Seakeeper gyrostabilisator på Sjøen for Alle!",
		firm: "Sea-Tek",
		l: "",
	},
	{
		wideImage: seatek4,
		description: "Dette er fremtidens interceptorer – få demo på messa!",
		firm: "Sea-Tek",
		l: "",
	},
	{
		wideImage: seakeeper,
		description: "Seakeeper har utviklet helt nye interceptorer. Test det på Sjøen for Alle.",
		firm: "Sea-Tek",
		l: "",
	},

	{
		wideImage: sjofart,
		description: "Må du ha høyhastighetsbevis?",
		firm: "Sjøfartsdirektoratet",
		l: "",
	},
	{
		wideImage: stromso,
		description: "Opplev Electric Folkboat – 100 % solcelle-elektrisk",
		firm: "Strømsøboat",
		l: "",
	},
	{
		wideImage: sunstream,
		description: "Snakk med oss om båtlift på Sjøen for Alle",
		firm: "Sunstream Boatlifts Nordic",
		l: "",
	},
	{
		wideImage: kellox,
		description: "Terhi 480 Cabin - Praktisk allrounder med lunt styrhus",
		firm: "Kellox",
		l: "",
	},{
		wideImage: kellox2,
		description: "Opplev årets nyheter fra Micore",
		firm: "Kellox",
		l: "",
	},

	{
		wideImage: pioner,
		description: "Se Pioners ultimate ungdomsbåt på Sjøen for Alle",
		firm: "Pioner",
		l: "",
	},
	{
		wideImage: pioner2,
		description: "Utforsk flerbruksbåten Pioner 16 Explorer",
		firm: "Pioner",
		l: "",
	},
]

let utstillereTmp = [
	{
		wideImage: img1,
		description: "Helt nye BRIG Navigator-serien",
		firm: "Hankø Marina",
		l: "https://hankomarina.no/",
	},
	{
		wideImage: img2,
		description: "Utforsk BRIG Eagle på Sjøen for Alle",
		firm: "Brig",
		l: "https://hankomarina.no/",
	},

	{
		wideImage: nordic,
		description: "Skager 660 – Den perfekte fritid- og landstedsbåt!",
		firm: "Nordic Boats",
		l: "https://www.nordicboats.no/merker/skager",
	},
	{
		wideImage: sandoy,
		description: "Ekspert på båtdekk – teak og syntetisk. Møt Sandøy Båtdekk på Sjøen for Alle",
		firm: "Sandøy Båtdekk",
		l: "https://baatdekkbutikken.no/ ",
	},
	{
		wideImage: cormate,
		description: "Cormate – Komfort og kraft for hele familien",
		firm: "Cormate",
		l: "https://www.cormate.com/",
	},
	{
		wideImage: orsta,
		description: "Flytebrygger og bølgedempere",
		firm: "Vik Ørsta AS",
		l: "https://www.vikorsta.no/marina/flytebrygger-og-bolgedempere/",
		...orstaStyle,
		fontSize: "0.9em",
	},
	{
		wideImage: orsta2,
		description: "Landganger",
		firm: "Vik Ørsta AS",
		l: "https://www.vikorsta.no/marina/landganger/",
		...orstaStyle,
		fontSize: "1em",
	},
	{
		wideImage: orsta3,
		description: "Utriggere og bommer",
		firm: "Vik Ørsta AS",
		l: "https://www.vikorsta.no/marina/utriggere-og-bommer/",
		...orstaStyle,
		fontSize: "1em",
	},
	{
		wideImage: boatboot,
		description: "BOATBOOT – Enkel å bruke i alt slags vær, året rundt!",
		firm: "BOATBOOT",
		l: "https://boatboot.no/",
	},
	{
		wideImage: sunstream2,
		description: "Slipp groing og bunnstoff – snakk båtlift med oss på Sjøen for Alle",
		firm: "Sunstream Boatlifts",
		l: "https://www.sunstreamboatlifts.se",
	},{
		wideImage: skippern,
		description: "Profesjonell formidling av båter.<br/> Skal du selge eller kjøpe båt?",
		firm: "Skippern Yachts",
		l: "https://skippern.yachts/no/",
		bg: '#0c677c',
		logoBg: '#bf7828'
	},
	{
		wideImage: skippern2,
		description: "Selg båten trygt og effektivt. Møt Skippern Yachts på Sjøen for Alle!",
		firm: "Skippern Yachts",
		l: "https://skippern.yachts/no/sell",
		bg: '#0c677c',
		logoBg: '#bf7828'
	},
	{
		wideImage: toxiclean,
		description: "<span style='color:#0f4c5c'><b>Vi renser spylevannet i din havn</b><br/><span style='font-weight: 490'>Enkelt, effektivt og uten store investeringer. Besøk oss på messa</span></span>",
		fontSize: "0.86em",
		firm: "Toxiclean",
		l: "https://toxiclean.no/",
		bg: '#f1e2d2',
	},
	{
		wideImage: oslo,
		description: "Lettbåt eller RIB til sesongen? Utforsk GALA på Sjøen for Alle",
		firm: "Oslo Båtimport",
		l: "https://www.baatimport.no/",
	},

	{
		wideImage: busterBoats,
		description: "Buster SuperMagnum - oppgradert med bedre ergonomi og funksjon",
		firm: "Buster Boats",
		l: "https://www.buster.fi/no/modeller/buster-supermagnum#factoryOptions=&motors=2271&hullSurfaceTreatments=&accentPanel=2076&accessories=",
	},
	{
		wideImage: yamarinBoats,
		description: "Omfavn elegansen, nyt komforten. Opplev nye Yamarin 80 DC",
		firm: "Yamarin Boats",
		l: "https://yamarin.com/no/modeller/yamarin-80-dc#accessories=&boatPackages=859&factoryOptions=&hullSurfaceTreatments="
	},
	{
		wideImage: yamarinCross,
		description: "Nye Cross 55 BR: Fremtidsrettet design med smart funksjonalitet",
		firm: "Yamarin Cross",
		l: "https://cross.boats/no/modeller/cross-55-br#factoryOptions=&accessories=&boatPackages=672"
	},

	{
		wideImage: terhi,
		description: "Terhi 480 og 450 serie – Solide og usenkbare båter for generasjoner – Nå på kampanje!",
		firm: "Terhi",
		l: "https://kellox.no/bat/terhi/terhi-kampanjeside/"
	},{
		wideImage: micore,
		description: "Micore - svenske båter av toppkvalitet. Se vår utstyrskampanje og nyheter!",
		firm: "Micore",
		l: "https://kellox.no/bat/micore/micore-kampanjeside/"
	},

	{
		wideImage: akeryachts,
		description: "Selge eller kjøpe båt? Møt oss på Sjøen for Alle eller kontakt oss her!",
		firm: "Aker Yachts",
		l: "https://akeryachts.no/"
	},

	{
		wideImage: pioner3,
		description: "Gjem nøklene for Fatter’n... om du vil ha din Pioner GO i fred!",
		firm: "Pioner Boats",
		l: "https://pionerboat.no/modeller/pioner-go/"
	},

	{
		wideImage: mercury,
		description: "Sommerkampanje!<br/><span style='font-weight: 490'>Mercury utenbordsmotorer fra 2,5-30 hk. Spar tusenvis av kroner på +45 modeller!</span>",
		firm: "Mercury Marine",
		l: "https://www.mercurymarine.com/no/no/Tilbud/motorkampanje-sma-pahengsmotorer",
		bg: "#003a50",
		logoBg: '#177197',
	},

	[
		{
			wideImage: coastkey1,
			description: "Nå kan du starte og stoppe motoren uten nøkler",
			firm: "CoastKey",
			l: "https://shop.coastkey.no/",
			bg: '#21263c',
			logoBg: '#eb5b25'
		},{
			wideImage: coastkey2,
			description: "Denne dødmannsknappen bruker du garantert!",
			firm: "CoastKey",
			l: "https://shop.coastkey.no/",
			bg: '#21263c',
			logoBg: '#eb5b25'
		},
	]
];


const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);
const utstillerFilter = params.get('firma'); // Already decoded

let utstillere = utstillerFilter? utstillereFake : utstillereTmp;

if (utstillerFilter)
	utstillere = utstillere.filter(u => u?.firm.toLowerCase() === utstillerFilter.toLowerCase())

// Add placeholder entries if less than 3
while (utstillere.length < 3) {
	utstillere.push({
		wideImage: eksempel,
		description: "Eksempel",
		firm: "Eksempel",
		l: "",
	});
}

export default utstillere;